import React, { FunctionComponent, useMemo } from 'react'
import styles from './Chart.module.sass'
import { Cell, Pie, PieChart } from 'recharts'
import { BASE_COLORS } from '../../../data-components/pickers/ColorPicker/ColorPicker'
import Difference from '../Difference/Difference'
import clsx from 'clsx'
import { Classes } from '../../../../styles'
import Skeleton from 'react-loading-skeleton'

export interface ChartData {
    name: string,
    current: number,
    previous: number,
}

interface Props {
    data: ChartData[],
    periods?: boolean,
    hide?: boolean
}

const SIZE = 180
const SHIFT = 10

const Chart: FunctionComponent<Props> = props => {
    const totalCurr = useMemo(() => props.data.reduce((acc, item) => acc + item.current,0), [props.data])
    const totalPrev = useMemo(() => props.data.reduce((acc, item) => acc + item.previous,0), [props.data])

    return <div className={styles.chart}>
        <div className={styles.container}>
            <PieChart height={SIZE + SHIFT} width={SIZE + SHIFT}>
                <Pie
                    height={SIZE}
                    width={SIZE}
                    cx={SIZE / 2}
                    cy={SIZE / 2}
                    innerRadius={SIZE / 4}
                    outerRadius={SIZE / 2}
                    data={props.data}
                    dataKey={'current'}
                >
                    {
                        props.data.map((entry, index) => <Cell
                            key={entry.name}
                            fill={BASE_COLORS[index]}
                        />)
                    }
                </Pie>
            </PieChart>
            <div className={styles.total} style={{
                top: SIZE / 2 + SHIFT / 2,
                left: SIZE / 2 + SHIFT / 2,
            }}>
                Общее кол-во:
                <Difference value={[totalCurr, totalPrev]} periods={props.periods}/>
            </div>
        </div>
        <div className={clsx(styles.legend, Classes.f11)}>
            {
                props.data.map((entry, index) => <div key={entry.name} className={styles.line}>
                    <div className={styles.mark} style={{background: BASE_COLORS[index]}}/>
                    {entry.name}:
                    {
                        props.hide ?
                            <Skeleton className={styles.loading}/> :
                            <Difference className={styles.difference} periods={props.periods} value={[entry.current, entry.previous]}/>
                    }
                </div>)
            }
        </div>
    </div>
}

export default Chart